// extracted by mini-css-extract-plugin
export default {"field":"InformationEdit_field__0FV6X","text":"InformationEdit_text__oPcwc"};